import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { useSelector } from 'react-redux';

import { DefaultAmountCard } from '../../../components';
import { DefaultAmountOptionsSkeleton } from '../../../components/skeletons/CheckoutPage/DefaultAmountOptions';

export function DefaultAmountOptions({ handleAmountChange, donationAmount }) {
    const donationDetails = useSelector(state => state.donationCheckout);

    const defaultAmountOptions =  useSelector(state => donationDetails.isRecurring ? state.currencyDefaultAmountOptions.recurring : state.currencyDefaultAmountOptions.nonRecurring)
    const [amountValues, setAmountValues] = useState([]);
    const [enableOthersOption, setEnableOthersOption] = useState(false);

    useEffect(() => {
        if (defaultAmountOptions) {
            const defaultAmountValues = []
            defaultAmountOptions.map(amount => {
                defaultAmountValues.push(amount.default_value)
            })
            setAmountValues(defaultAmountValues)
        }
    }, [defaultAmountOptions])

    useEffect(() => {
        const amountPresentInOptions = amountValues.find(amount => parseInt(amount) == donationAmount)
        amountPresentInOptions ? setEnableOthersOption(false) : setEnableOthersOption(true);
    }, [donationAmount])

    return defaultAmountOptions.length ? <Grid container className="AmountOptions">
        {
            defaultAmountOptions && defaultAmountOptions.map(option => {
                return <Grid item xs={3} key={option.id}>
                    <DefaultAmountCard key={option.id} currency={option} handleDefaultAmountSelect={handleAmountChange} donationAmount={donationAmount} />
                </Grid>

            })
        }
        <Grid item xs={3}>
            <Button
                id="customAmount"
                name="donationAmount"
                variant={enableOthersOption ? 'contained' : 'outlined'}
                value={'Others'}
                sx={{
                    borderColor: '#C8C8C8',
                    color: enableOthersOption ? null : '#495057',
                }}
                onClick={handleAmountChange}
                fullWidth
            >
                Others
            </Button>
        </Grid>
    </Grid> : <DefaultAmountOptionsSkeleton />
}